import axios from 'axios'
import { pumatracApi } from '../utils/axios-config'

export default {

  resetPassword ({email}) {
    return pumatracApi.post(`/passwords?email=` + email, {},{})
  },

  updatePassword ({token, password}) {
    return pumatracApi.put(`/passwords?token=` + token + `&password=` + encodeURIComponent(password) , {},{})
  },

  login ({email, password}) {
    return pumatracApi.post(`/sessions`, {
        email,
        password
    },{})
  },

  register ({email, password, consents, provider, providerId}) {
    let data = {
        user: {}
    };
    if(email && password) {
        data.user = {
            email,
            password,
            consents
        }
    } else if (provider && providerId) {
        data.user = {
            provider,
            providerId
        }
        if(email) {
            data.user.email = email;
        }
        if(consents) {
          data.user.consents = consents
        }
    }
    return pumatracApi.post(`/users`, data, {})
  },

  updateProfile (data) {
    return pumatracApi.put(`/users/me`, data, {})
  },

  consent(screen, status) {
    return pumatracApi.post(`/users/me/consents/` + screen + '/' + status, {}, {});
  },

  loadConsent() {
    return pumatracApi.get(`/users/me/consents/`);
  },

  changePassword(data) {
      return pumatracApi.put(`/users/me/password`, data, {})
  },

  me () {
    return pumatracApi.get('/users/me/')
  },

  completeWorkout ({completedWorkout}) {
      const data = {
          completed_workout: completedWorkout
      }
      return pumatracApi.post(`/users/me/completed_workouts`, data, {})
  },

  getCompletedWorkouts() {
      return pumatracApi.get(`/users/me/completed_workouts`)
  },

  deleteAccount(data) {
    return pumatracApi.delete(`/users/me/`, {data}, {})
  }

}
